const ths = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortable: true,
    sortableId: 'id'
  },
  {
    id: 2,
    label: 'Journey category',
    intlKey: 'table.journey_category',
    sortable: true,
    sortableId: 'ajEvent.ajEventCategory.value'
  },
  {
    id: 3,
    label: 'Award Level',
    intlKey: 'table.level',
    sortable: true,
    sortableId: 'ajEvent.awardLevel.value'
  },
  {
    id: 4,
    label: 'Journey activity',
    intlKey: 'table.journey_activity',
    sortable: true,
    sortableId: 'ajEvent.activityCategory.id'
  },
  {
    id: 5,
    label: 'Journey type',
    intlKey: 'table.journey_type',
    sortable: true,
    sortableId: 'ajEvent.activityCategory.parent.id'
  },
  {
    id: 6,
    label: 'Start date',
    intlKey: 'table.start_date',
    sortable: true,
    sortableId: 'ajEvent.startDate'
  },
  {
    id: 7,
    label: 'End date',
    intlKey: 'table.end_date',
    sortable: true,
    sortableId: 'ajEvent.endDate'
  },
  {
    id: 8,
    label: 'Created by',
    intlKey: 'table.created_by',
    sortable: true,
    sortableId: 'ajEvent.createdBy'
  },
  {
    id: 9,
    label: 'Assessor',
    intlKey: 'table.assessor',
    sortableId: 'residentialProject.assessorName'
  },
  {
    id: 10,
    label: 'Action',
    intlKey: 'table.action',
    sortable: false
  }
]

export default ths
